<div class="position-reletivediv popup-inner-space border-bottom-grey">
    <div class="text-right flow-right d-flex justify-content-between">
             <h4 id="heading-control" class="right-sidebar-heading color_black mb-0" id="dashboard-main">{{this.title}} - {{data.selectedmetername}}</h4>
        <img src="assets/images/close_icon.svg" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close()">
    </div>
</div>
<div  style="padding: 0px 15px 10px; position: relative;">
    <form class="width100" [formGroup]="parameterconfigform" *ngIf="!isForViewFormula">
        <div class="container-data56 popup-inner-space mt-3">
            <div class="errmsg" *ngIf="errorMsg">{{errorMsg}}</div>
            <div class="sucessmsg" *ngIf="successMsg">{{successMsg}}</div>
        </div>
        <div class="row marginleftright0">
            <div class="col-lg-3 paddingleftright5">
                <div class="fxg-field fxg-field2">
                     <mat-form-field style="display:block;" title="Register Name">
                        <mat-select formControlName="RegisterDataId"  (selectionChange)="OnChangeRegister($event)">
                            <mat-option value="">(Select RegisterName)</mat-option>
                            <mat-option MatFormFieldControl="RegisterDataId" *ngFor="let lstregister of RegisterData"
                             value="{{lstregister.RegisterDataId}}" [disabled]="lstregister.isDisabled">
                                {{lstregister.RegisterName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="error_msg" *ngIf="displayMessage.MeterId && !isDisplayFormula">{{displayMessage.MeterId}}</span>
                </div>
            </div>
            <div class="col-lg-3 paddingleftright5">
                <div class="fxg-field fxg-field2">
                    <span class="error_msg"
                        *ngIf="displayMessage.RegisterDataId && !isDisplayFormula">{{displayMessage.RegisterDataId}}</span>
                </div>
            </div>
        
            <div class="col-lg-6 paddingleftright5">
                <div class="d-flex justify-content-end">
                <button class="btncommon btn-orange search-usermater mr-4" id="SearchusermasterSearch"
                    (click)="AddRegisters()">Add</button>
                     <button class="btncommon search-usermater" id="SearchusermasterSearch" *ngIf="ParameterList.length > 0" (click)="AddFormula()">Add
                    Formula</button>
                </div>
            </div>                              
        </div>
        <div class="table-scroll-newsite tableBR-1">
            <table class="table table-layout-fixed">
                <thead class="companytable thead-data td-data-main">
                    <tr class="tr-padding">
                        <th class="width-10 color_black pad_left_10">PC No.</th>
                        <th class="color_black pad_left_10">Register Name</th>
                        <th class="text-right">Action</th>
                    </tr>
                </thead>
                <tbody class="table-responsive-sechedule">
                    <tr *ngFor="let data of ParameterList; let i = index">
                        <td class="width-10">{{data.RegisterNo}}</td>
                        <td class="">{{data.RegisterName}}</td>
                        <td class=" text-right">
                            <img src="assets/images/delete.svg" alt="..." class="img-fluid closeicon2 cursor-pointer"
                                (click)="DeleteParamterData(i)" id="delete_icon">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      
        <div class="row marginleftright0 margin-top-5" *ngIf="isDisplayFormula">
            <div class="col-lg-5 paddingleftright5">
               
                <input type="text" 
                class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup addnew_cust" placeholder="Formula" type="text"
                name="Formula" id="Formula" formControlName="Formula" required="" aria-required="true"
                data-errmsg="Sorry, this is a required field.">
                
                <p class="error_msg" *ngIf="displayMessage.Formula">{{displayMessage.Formula}}</p>
            </div>
            <div class="col-lg-4 paddingleftright5">
                <input type="text"
                class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup addnew_cust" placeholder="Register Name" type="text"
                name="RegisterName" id="RegisterName" formControlName="RegisterName" required="" aria-required="true"
                data-errmsg="Sorry, this is a required field.">
                <p class="error_msg" *ngIf="displayMessage.RegisterName">{{displayMessage.RegisterName}}</p>
            </div>
            <div class="col-lg-3 px-0 text-right">
                <button type="submit" class="btncommon search-usermater" id="SearchusermasterSearch" (click)="SaveParameterConfigData()">Save</button>
            </div>
        </div>
    </form>
    <div *ngIf="isForViewFormula">
        <label>{{Formula}}</label>
    </div>
</div>